export default __webpack_public_path__ + "static/Chomchob_logo-c0485f3afd50a08d40d02c06dd3a2dd2.png";